// extracted by mini-css-extract-plugin
export default {"addressAction":"z3-z","loading":"A3-z"};